import { render } from "./DemoBreadcrumb.vue?vue&type=template&id=9b3fac44"
import script from "./DemoBreadcrumb.vue?vue&type=script&lang=js"
export * from "./DemoBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__